export default "__VITE_ASSET__BlCHWmRy__"